import styled from '@emotion/styled';
import React from 'react';

interface NumberFieldProps {
  value: number | undefined;
  onChange: (value: number) => void;
  step?: number;
  min?: number;
  max?: number;
}

const NumberField: React.FC<NumberFieldProps> = ({ value, onChange, step = 1, min, max }) => {
  const display = value === undefined || Number.isNaN(value) ? '' : Number(value.toFixed(2));
  return (
    <Input
      type="number"
      value={display}
      step={step}
      min={min}
      max={max}
      onChange={(e) => {
        const v = parseFloat(e.target.value);
        if (!Number.isNaN(v)) onChange(v);
      }}
    />
  );
};

export default NumberField;

const Input = styled.input`
  width: 100%;
  min-width: 0;
  padding: 4px 6px;
  font-size: 13px;
  color: #111827;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #ffffff;
  outline: none;

  &:focus {
    border-color: #9ca3af;
  }
`;
